import {team} from "@irati-web/insights/src/graph/team"
import {survey} from "@irati-web/insights/src/graph/surveys"
import {question} from "@irati-web/insights/src/graph/question"
import {interest} from "@irati-web/insights/src/graph/interest"
import {driver} from "@irati-web/insights/src/graph/driver"

const user = `{
  uuid
  profile_img
  firstname
  lastname
}
`

const emailProperties = `
  bodyHeading
  bodyText
  ctaHref
  ctaText
  subject
`

const emails = `{
  notificationUserIds
  notificationUsers {
    results ${user}
  }

  preSurveyReminder {
    ${emailProperties}
    hoursBefore
  }

  surveyOpenedNotification {
    ${emailProperties}
    enabled
  }

  userDeadlineReminder {
    ${emailProperties}
    hoursBefore
  }

  userReminder {
    ${emailProperties}
    afterDays
  }

  userSurvey {
    ${emailProperties}
  }

  senderName
  senderUsername

}`

const preferences = `{
  actionBoardUrl
  driverCommentTitle
  eNPSPeriodType
  eNPSPeriodValue
  questionSelectionType

  emails ${emails}

  groupIds

  includeActionBoard
  includeDriverComment
  includeENPS

  placeholders {
    tenant
  }

  questionCount
  sendToAll

  teamIds
  teams {
    results {
      ${team}
    }
  }

  userIds
  users {
    results ${user}
  }
}`

const validationError = `
  code
  status
  dev_message
  reference
`


export const schedule = `
  Etag
  createdAt
  id
  interestId
  lastENPSTriggeredAt
  lastTriggeredAt
  nextTriggerAt
  nextTriggerAtOverride
  periodType
  periodValue
  preferences ${preferences}
  reference
  runCount
  runOnce
  startAt
  status
  tenant
  firstSurvey @include (if: $withFirstSurvey) {
     ${survey}
  }
  latestSurvey @include (if: $withLatestSurvey) {
     ${survey}
  }
  nthSurvey(nthSurveyIndex: $nthSurveyIndex) @include (if: $withNthSurvey) {
     ${survey}
  }
  surveyCount @include (if: $withSurveyCount)
  validationErrors: validationErrorsV2 @include (if: $withValidationErrors){
    ${validationError}
  }
  teamsSentTo {
    results {
      ${team}
    }
  }
  questions: questionsV2 @include (if: $withQuestions){
    total
    count
    results {
      ${question}
    }
  }
  interest @include (if: $withInterest){
    ${interest}
  }
  drivers: driversV2 @include (if: $withDrivers){
    results {
      ${driver}
    }
  }
  responseCount(
    team: $team,
    surveyOpenedAfter: $minOpenedAt
  ) @include (if: $withResponseCount)
`

// Should default $withValidationErrors to true
export const scheduleParams = `
  $withFirstSurvey: Boolean = false,
  $withLatestSurvey: Boolean = false,
  $withNthSurvey: Boolean = false,
  $withResponseCount: Boolean = false,
  $withQuestionStats: Boolean = false,
  $withValidationErrors: Boolean = true,
  $withQuestions: Boolean = false,
  $withQuestionDriver: Boolean = false,
  $withInterest: Boolean = false,
  $withQuestions_Interest: Boolean = false,
  $withDrivers: Boolean = false,
  $withSurveyCount: Boolean = false,
  $team: String = "",
  $driverId: String = "",
  $minOpenedAt: String = "",
  $nthSurveyIndex: Int
`

export default schedule
